import { t, Trans } from 'common-translation/tools';
import React, { Fragment, useEffect, useState } from 'react';

const DocProductRender = ({ icon, redirectUrl, redirectTitle }) => {
  const [count, setCount] = useState(6);
  const [formateTitle, setFormateTitle] = useState(redirectTitle);
  useEffect(() => {
    const timerId = setTimeout(() => {
      if (count) {
        setCount(count - 1);
      } else {
        location.href = redirectUrl;
      }
    }, 1000);

    return () => clearTimeout(timerId);
  }, [count]);

  useEffect(() => {
    if (redirectUrl === '/document/product' || redirectUrl === '/document/api') {
      setFormateTitle(t(redirectTitle));
    }
  }, [redirectUrl, redirectTitle]);

  return <Fragment>
    <div className="com-none-panel page">
      <div className="com-none-panel-object">
        <i className={`com-none-panel-icon ${icon}`} />
      </div>
      <div className="com-none-panel-main">
        <h3 className="com-none-panel-title">{t('Page Not Found')}</h3>
        <p>
          <Trans count={count} formateTitle={formateTitle}>
            <span id="doc_countdown" style={{ color: '#0170cc' }}>
              {{ count }}
            </span>
            秒后将自动跳转至<a id="doc_home" href={redirectUrl} style={{ color: '#0170cc', padding: '0 2px' }}>
              {{ formateTitle }}
            </a>
          </Trans>
          ！
        </p>
      </div>
    </div>
  </Fragment>;
};

export default DocProductRender;
